/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
if (typeof window !== 'undefined' && window.__webpack_public_path__) {
  __webpack_public_path__ = window.__webpack_public_path__;
}

const nothing = null;
export default nothing;
